import React, { useState, useEffect } from 'react'
import { Col, Panel, Row, Modal, Button, Icon, Message } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../utils/loading'
import SubProjectIncomeRecordInfo from './SubProjectIncomeRecordInfo'
import SubProjectIncomeRecordForm from './SubProjectIncomeRecordForm'
import SubProjectIncomeRecordTable from './SubProjectIncomeRecordTable'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import moment from 'moment'
import ConfirmWidget from '../confirm/ConfirmWidget'
import {
  saveSubProjectIncomeRecord,
  deleteSubProjectIncomeRecord,
  downloadSubProjectIncomeRecordAttacthment,
  downloadSubProjectIncomeRecordVoucherFile,
} from '../../redux/actions/subProjectIncomeRecord'
import notification from '../../utils/notification'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import { sessionGetItemObj, sessionGetItemStr, sessionSetItemStr } from '../../utils/sessionHelpers'
import { useHistory } from 'react-router-dom'
import globalMsgUtil from '../../utils/globalMsgUtil'
import { previewFile } from '../../utils/fileUtil'
import SubProjectIncomeRecordView from './SubProjectIncomeRecordView'
import { downloadIncomeSubProjectVoucherListFile } from '../../redux/actions/projectBasedItems'

export default function SubProjectIncomeRecordWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [request, setRequest] = useState()
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [isShowConfirmDelete, setIsShowConfirmDelete] = useState(false)
  const [isEnableEdit, setIsEnableEdit] = useState()
  const [requestBody, setRequestBody] = useState()
  const projectCode = sessionGetItemStr('projectCode')
  const subProjectCode = sessionGetItemStr('subProjectCode')
  const { periodNo } = sessionGetItemObj('subProjectPeriodInfo')
  const subIncomeId = sessionGetItemStr('subIncomeId')
  const isViewOnly = !!sessionGetItemStr('isViewOnly')

  let history = useHistory()

  const handleCallDelete = async () => {
    startLoading()
    setIsLoading(true)
    setIsError(false)

    try {
      const response = await deleteSubProjectIncomeRecord(subIncomeId)
      if (response) {
        notification.open('success', {
          title: globalMsgUtil.DELETE_SUCCESS,
        })
        setIsShowConfirmDelete(false)
        history.goBack()
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        console.log(e?.response?.data)
        setIsError(e.response.data.errorMessage || globalMsgUtil.SET_IS_ERROR)
      } else {
        setIsError(globalMsgUtil.SET_IS_ERROR)
      }
      setIsShowConfirmDelete(false)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleCallService = async () => {
    startLoading()
    setIsLoading(true)
    setIsError(false)

    try {
      const response = await saveSubProjectIncomeRecord(requestBody)

      if (response) {
        setFormSchema(response.model)
        setRequestBody()
        sessionSetItemStr('subIncomeId', response.model.id)
        notification.open('success', {
          title: globalMsgUtil.SAVE_SUCCESS,
        })
        setIsShowConfirm(false)
        setTimeout(() => {
          if (subIncomeId) {
            location.reload()
          } else {
            history.goBack()
          }
        }, 1000)
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        console.log(e?.response?.data)
        setIsError(e.response.data.errorMessage || globalMsgUtil.SET_IS_ERROR)
      } else {
        setIsError(globalMsgUtil.SET_IS_ERROR)
      }
    }

    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('data', data)

    const formData = new FormData()

    formData.append('Id', subIncomeId || '')
    formData.append('ProjectCode', projectCode || '')
    formData.append('subProjectCode', subProjectCode || '')
    formData.append('PeriodNo', periodNo || '')
    formData.append('voucherNumber', data.voucherNumber || '')
    formData.append('ReferenceNumber', data.referenceNumber || '')
    formData.append('Description', data.description || '')
    formData.append('VoucherDate', moment(data.voucherDate).format('YYYY/MM/DD') || '')

    data.attachFiles &&
      data.attachFiles?.forEach((element) => {
        formData.append('AttachFiles', element.blobFile)
      })

    data.deleteFileIds &&
      data.deleteFileIds?.forEach((element) => {
        formData.append('DeleteFileIds', element)
      })

    const formTable = data.table?.filter((i) => !i.isSummary) || []
    console.log('formTable', formTable)

    if (formTable.length > 0) {
      formTable?.map((item, index) => {
        if (item.id) {
          formData.set(`FormTable[${index}].expenseList`, item.expenseList || '')
          formData.set(`FormTable[${index}].expenseTotal`, item.expenseTotal || 0)
          formData.set(`FormTable[${index}].Id`, item.id?.indexOf('addNew') != -1 ? '' : item.id)
        }
      })
    } else {
      notification.open('error', {
        title: 'กรุณาเพิ่มรายการบันทึกรับ อย่างน้อย 1 รายการ',
      })
      return
    }

    // setRequest(formData)
    setRequestBody(formData)
    setIsShowConfirm(true)
  }

  const onPreview = async (filePath) => {
    startLoading()
    try {
      var files = filePath?.split('/')
      var file = await downloadIncomeSubProjectVoucherListFile(filePath)

      previewFile(file, files[files.length - 1])
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
  }

  return (
    <>
      <Panel shaded collapsible defaultExpanded header={''} bordered>
        <SubProjectIncomeRecordInfo schema={formSchema?.projectInfo} />

        {!isViewOnly && !formSchema?.disabled ? (
          <>
            <SubProjectIncomeRecordForm
              schema={formSchema?.form}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              getValues={getValues}
              setValue={setValue}
              clearErrors={clearErrors}
              setIsEnableEdit={setIsEnableEdit}
            />
          </>
        ) : (
          <>
            <SubProjectIncomeRecordView schema={formSchema?.form} />
          </>
        )}

        <SubProjectIncomeRecordTable
          schema={formSchema?.form?.formTable}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          getValues={getValues}
          setValue={setValue}
          clearErrors={clearErrors}
          isEnableEdit={!formSchema?.form?.isReceiveAnnuity || isEnableEdit}
          isViewMode={isViewOnly || formSchema?.disabled}
        />

        <div>
          <br />
          <Row>
            {isError && <Message showIcon type="error" description={isError} />}
            <Col lg={12} md={12} sm={24} xs={24}>
              {!isViewOnly && !formSchema?.disabled && (
                <Button
                  color="red"
                  appearance="link"
                  disabled={!formSchema.id}
                  onClick={() => setIsShowConfirmDelete(true)}
                >
                  <Icon icon="trash" size="lg" /> ลบเอกสาร
                </Button>
              )}
            </Col>
            <Col lg={12} md={12} sm={24} xs={24} style={{ textAlign: 'right' }}>
              <Button
                color="blue"
                appearance="link"
                // disabled={!formSchema?.id}
                onClick={() => {
                  onPreview(formSchema?.id)
                }}
              >
                <Icon icon="search" size="lg" /> ใบสำคัญรับ
              </Button>
              {!isViewOnly && !formSchema?.disabled && (
                <>
                  <SaveButton onClick={handleSubmit(onSubmit)}>บันทึก</SaveButton>
                  <CancelButton
                    onClick={() => {
                      history.goBack()
                    }}
                  >
                    ยกเลิก
                  </CancelButton>
                </>
              )}
            </Col>
          </Row>
        </div>
      </Panel>

      <ConfirmWidget
        title={globalMsgUtil.CONFIRM_SAVE_TITLE}
        show={isShowConfirm}
        detail={globalMsgUtil.CONFIRM_SAVE_DETAIL}
        onCancle={() => setIsShowConfirm(false)}
        onConfirm={handleCallService}
      />

      <ConfirmWidget
        title={globalMsgUtil.CONFIRM_DELETE_DOC_TITLE}
        show={isShowConfirmDelete}
        detail={globalMsgUtil.CONFIRM_DELETE_DOC_DETAIL}
        onCancle={() => setIsShowConfirmDelete(false)}
        onConfirm={handleCallDelete}
      />
    </>
  )
}
